import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { App } from './App';
import { theme } from './theme';
import { LanguageProvider } from './i18n';
import { ClientErrorBoundary, installClientErrorReporting } from './errors';

installClientErrorReporting();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LanguageProvider>
        <ClientErrorBoundary><App /></ClientErrorBoundary>
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>,
);
